import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

function ModernFooter() {
	return (
		<Box
			component="section"
			sx={{
				display: 'flex',
				gap: '2rem',
				width: 'var(--csmd-cl-width-main)',
				margin: 'auto',
				color: 'var(--csmd-cl-text-primary-footer)',
				paddingTop: '2rem',
				paddingBottom: '2rem',
			}}
		>
			<Stack direction="column" spacing={1} sx={{ width: '25%' }}>
				<Typography variant="h5">The Bear House</Typography>
				<Typography variant="body2" sx={{ color: 'var(--csmd-cl-text-secondary-footer)' }}>
					Lorem ipsum dolor sit amet, consectetur adipiscing elit. Auctor libero id et, in gravida.
					Sit diam duis mauris nulla cursus. Erat et lectus vel ut sollicitudin elit at amet.
				</Typography>
			</Stack>
			<Stack direction="column" spacing={0.25} sx={{ width: '25%' }}>
				<Typography variant="h5">About Us</Typography>
				<Typography variant="body2" sx={{ color: 'var(--csmd-cl-text-secondary-footer)' }}>
					Careers
				</Typography>
				<Typography variant="body2" sx={{ color: 'var(--csmd-cl-text-secondary-footer)' }}>
					Our Stores
				</Typography>
				<Typography variant="body2" sx={{ color: 'var(--csmd-cl-text-secondary-footer)' }}>
					Our Cares
				</Typography>
				<Typography variant="body2" sx={{ color: 'var(--csmd-cl-text-secondary-footer)' }}>
					Terms & Conditions
				</Typography>
				<Typography variant="body2" sx={{ color: 'var(--csmd-cl-text-secondary-footer)' }}>
					Privacy Policy
				</Typography>
			</Stack>
			<Stack direction="column" spacing={0.25} sx={{ width: '25%' }}>
				<Typography variant="h5">Customer Care</Typography>
				<Typography variant="body2" sx={{ color: 'var(--csmd-cl-text-secondary-footer)' }}>
					Help Center
				</Typography>
				<Typography variant="body2" sx={{ color: 'var(--csmd-cl-text-secondary-footer)' }}>
					How to Buy
				</Typography>
				<Typography variant="body2" sx={{ color: 'var(--csmd-cl-text-secondary-footer)' }}>
					Track Your Order
				</Typography>
				<Typography variant="body2" sx={{ color: 'var(--csmd-cl-text-secondary-footer)' }}>
					Corporate & Bulk Purchasing
				</Typography>
				<Typography variant="body2" sx={{ color: 'var(--csmd-cl-text-secondary-footer)' }}>
					Returns & Refunds
				</Typography>
			</Stack>
			<Stack direction="column" spacing={0.25} sx={{ width: '25%' }}>
				<Typography variant="h5">Contact Us</Typography>
				<Typography variant="body2" sx={{ color: 'var(--csmd-cl-text-secondary-footer)' }}>
					460-4747 67 St Red Deer, AB T4N 6H3
				</Typography>
				<Typography variant="body2" sx={{ color: 'var(--csmd-cl-text-secondary-footer)' }}>
					Phone: 403-348-0200
				</Typography>
			</Stack>
		</Box>
	);
}

export default ModernFooter;
